import { FC } from 'react';
import { Perform } from './perform';

interface PerformCustomTextProps {
    name: string;
    value: string;
}

export const PerformCustomText: FC<PerformCustomTextProps> = ({
    value,
    name,
}: PerformCustomTextProps) => <Perform name={name} text={value} />;
